export const GET_EXCEPTION_CONFIG_LIST = 'GET_EXCEPTION_CONFIG_LIST';
export const SET_EXCEPTION_CONFIG_LIST = 'SET_EXCEPTION_CONFIG_LIST';
export const DELETE_EXCEPTION_CONFIG = 'DELETE_EXCEPTION_CONFIG';
export const SAVE_EXCEPTION_CONFIG = 'SAVE_EXCEPTION_CONFIG';
export const UPLOAD_EXCEPTION_CONFIG = 'UPLOAD_EXCEPTION_CONFIG';
